import { render, staticRenderFns } from "./VInputDate.vue?vue&type=template&id=348cc73e&"
import script from "./VInputDate.vue?vue&type=script&lang=js&"
export * from "./VInputDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports